import React from 'react';
import { Link } from 'react-router-dom';

import { Icon } from '@app/components/Icon';

const BreadCrumbsHome = ({home}:{home?: string}) => (
        <Link to={home || '#'} className="kt-subheader__breadcrumbs-home">
            <Icon icon="home" />
        </Link>
    );

export default BreadCrumbsHome;
